import { Dispatch, FC, SetStateAction, useMemo } from "react";
import {
    SearchBar,
    SearchBarDataHandler,
} from "../../../assets/components/SearchBar/SearchBar";
import { OptionSearchBarSelectStatus } from "../../../assets/components/SearchBar/SearchBarSelectStatus/helpers";
import { Products } from "../../../models/models";
import { OptionList } from "../../../assets/helpers/helpers";
import { TransactionStatus } from "../model";

interface Props {
    products?: Products;
    dataHandler: Dispatch<SetStateAction<SearchBarDataHandler>>;
    dateRange: {
        startDate: SearchBarDataHandler["startDate"];
        endDate: SearchBarDataHandler["endDate"];
    };
}

const TransactionsSearchBar: FC<Props> = ({
    products,
    dataHandler,
    dateRange,
}) => {
    const productsOptionList: OptionList = useMemo(() => {
        return products?.map(({ name, id }) => {
            return {
                id,
                name,
            };
        }) as OptionList;
    }, [products]);

    const timeOptionsOptionList: OptionList = useMemo(() => {
        return [
            { id: 1, name: "Last 24 hours" },
            { id: 2, name: "Last 7 days" },
            { id: 3, name: "Last 1 month" },
        ];
    }, []);

    const transactionStatusOptions: OptionSearchBarSelectStatus[] = useMemo(() => [
        { id: 0, status: TransactionStatus.Pending, name: "Pending", checked: true, color: "yellow" },
        { id: 1, status: TransactionStatus.Completed, name: "Completed", checked: true, color: "green" },
        { id: 2, status: TransactionStatus.Failed, name: "Failed", checked: true, color: "red" },
        { id: 3, status: TransactionStatus.Refunded, name: "Refunded", checked: true, color: "blue" },
    ], []);

    return (
        <SearchBar
            productOptions={productsOptionList}
            dateRangeOptions={timeOptionsOptionList}
            initialData={{
                dateRange,
            }}
            dataHandler={dataHandler}
            searchInput={{
                placeholder: "Transaction ID",
            }}
            searchByOrderId={{
                placeholder: "Order ID",
            }}
            statusOptions={transactionStatusOptions}
            showComponents={{
                dataPikerDateRange: true,
                selectStatus: true,
            }}
        />
    );
};

export default TransactionsSearchBar;
